<template>
  <v-toolbar :color="hasSelectedGuias ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" dense>
    <v-checkbox
      @change="handleCheckboxClick"
      :value="selectedAll"
      :indeterminate="indeterminate"
      :disabled="disabledCheckbox"
      :label="label"
      color="primary"
      hide-details
      dense
    />
    <div v-if="hasSelectedGuias" class="primary--text">{{ selectedFaturamentoGuiasCount | pluralize }} de {{ totalFaturamentoGuias }}</div>
    <v-spacer />
    <v-btn
      v-if="hasSelectedGuias"
      @click="handleVerGuiasSelecionadas"
      color="primary"
      small
      outlined
    >
      Ver itens das guias selecionadas
    </v-btn>
    <v-tooltip v-else :disabled="hasGuiasAssociadas" bottom>
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs">
          <v-btn
            @click="handleVerGuiasAssociadas"
            :disabled="!hasGuiasAssociadas"
            color="primary"
            small
            outlined
          >
            Ver itens das guias associadas
          </v-btn>
        </div>
      </template>
      <span>Nenhuma guia de faturamento associada</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('conciliacao', ['selectedFaturamentoGuiasCount', 'totalFaturamentoGuias', 'hasGuiasAssociadas']),
    selectedAll () {
      return this.selectedFaturamentoGuiasCount > 0 && this.selectedFaturamentoGuiasCount === this.totalFaturamentoGuias
    },
    indeterminate () {
      return this.selectedFaturamentoGuiasCount > 0 && this.selectedFaturamentoGuiasCount < this.totalFaturamentoGuias
    },
    disabledCheckbox () {
      return this.totalFaturamentoGuias === 0
    },
    label () {
      return this.selectedFaturamentoGuiasCount === 0 ? 'Selecionar todas as guias' : undefined
    },
    hasSelectedGuias () {
      return this.selectedFaturamentoGuiasCount > 0
    }
  },
  methods: {
    handleCheckboxClick (checked) {
      if (checked) {
        this.$store.dispatch('conciliacao/selectAllFaturamentoGuias')
      } else {
        this.$store.dispatch('conciliacao/deselectAllFaturamentoGuias')
      }
    },
    handleVerGuiasSelecionadas () {
      this.$store.dispatch('conciliacao/openFaturamentoGuiasSelecionadas')
    },
    handleVerGuiasAssociadas () {
      this.$store.dispatch('conciliacao/openFaturamentoGuiasAssociadas')
    }
  },
  filters: {
    pluralize (count) {
      if (count === 0) {
        return 'Nenhuma guia selecionada'
      } else if (count === 1) {
        return '1 guia selecionada'
      } else {
        return `${count} guias selecionadas`
      }
    }
  }
}
</script>
